import React from 'react';

import Highcharts from 'highcharts';

import TotalOrders from '../yoello-lib/modules/components/Analytics/TotalsListWidget/TotalsListItem/Icons/TotalOrders';
import RevIcon from '../yoello-lib/modules/components/Analytics/TotalsListWidget/TotalsListItem/Icons/Revenue';
import AvgSpendIcon from '../yoello-lib/modules/components/Analytics/TotalsListWidget/TotalsListItem/Icons/AvgSpend';
import TotalTipsIcon from '../yoello-lib/modules/components/Analytics/TotalsListWidget/TotalsListItem/Icons/TotalTips';
import AvgTipsIcon from '../yoello-lib/modules/components/Analytics/TotalsListWidget/TotalsListItem/Icons/AvgTips';
import UniqueIcon from '../yoello-lib/modules/components/Analytics/TotalsListWidget/TotalsListItem/Icons/UniqueCustomers';
function tooltipFormatter() {
    //Hacky solution
    //@ts-ignore
    const decimalPlaces = this.points[0].series.name.indexOf('Average') > -1 ? 2 : 0;
    //@ts-ignore
    return `<b>${this.points[0].series.name}</b><br><span>${this.y.toFixed(decimalPlaces)}</span>`;
}

export const LINECHART = {
    legend: {
        enabled: false,
    },
    credits: {
        enabled: false,
    },
    tooltip: {
        formatter: tooltipFormatter,
        positioner: (x: number, y: number, point: { plotX: number }) => { return { x: point.plotX - 12, y: 0 } },
        animation: false,
        borderColor: 'transparent',
        useHTML: true,
        shadow: false,
        backgroundColor: null,

        style: {
            padding: 0
        },
        crosshairs: {
            color: '#CDCDCD',
            dashStyle: 'solid'
        },
        shared: true
    },
    chart: {
        spacingTop: 48,
        type: 'areaspline',
        backgroundColor: 'transparent',
        style: {
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Open Sans', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
        }
    },
    title: {
        text: ''
    },
    xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
            day: '%H:%M'
        },
    },
    yAxis: {
        title: {
            text: '',
        },
        labels: {
            enabled: false
        }
    },
    plotOptions: {
        areaspline: {
            marker: {
                enabled: false,
            }
        },
        series: {
            lineColor: '#815FE4',
            fillColor: {
                linearGradient: [0, 0, 0, 300],
                stops: [
                    [0, Highcharts.color('#815FE4').setOpacity(0.5).get('rgba')],
                    [1, Highcharts.color('#815FE4').setOpacity(0).get('rgba')],
                ]
            }
        }
    },
}
export const COLUMNCHART = (columns: number) => {
    const rotation =
      columns >= 15
        ? 90
        : columns >= 5
        ? 60
        : 30;

    return {
        legend: {
            enabled: false,
        },
        credits: {
            enabled: false,
        },
        chart: {
            spacingTop: 10,
            type: 'column',
            backgroundColor: 'transparent',
            style: {
                fontFamily: "'Open Sans'"
            }
        },
        title: {
            text: ''
        },
        xAxis: {
            type: 'category',
            labels: {
                rotation: rotation,
                style: {
                    fontSize: '12x',
                    fontFamily: 'Open Sans'
                }
            }
        },
        yAxis: {
            visible: false
        },
        plotOptions: {
            series: {
                className: "BLAH BLAHHH",
                borderWidth: 0,
                dataLabels: {
                    enabled: false,
                    format: '{point.y:.1f}%'
                },
                color: {
                    linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                    stops: [
                        [0, '#C1CAE1'],
                        [1, '#F3F4F9']
                    ]
                }
            },
            pointWidth: 30,
            maxPointWidth: 30
        },
        tooltip: {
            enabled: false,
        }
    }
}

export const TOTALS_LIST = {
    title: <div>Today's Total Statistics</div>,
    items: [
        { id: "order", label: 'analytics.totals.order', icon: <TotalOrders />, loading: true , tooltip:"TotalsOrderTooltip" },
        { id: "revenue", label: 'analytics.totals.revenue', icon: <RevIcon />, loading: true , tooltip:"TotalsRevenue" },
        { id: "avg_spend", label: 'analytics.totals.avg_spend', icon: <AvgSpendIcon />, loading: true , tooltip:"TotalsAvgSpend"},
        { id: "avg_tips", label: 'analytics.totals.avg_tips', icon: <AvgTipsIcon />, loading: true , tooltip:"TotalsAvgTips" },
        { id: "total_tips", label: 'analytics.totals.total_tips', icon: <TotalTipsIcon />, loading: true , tooltip:"TotalsTotalTips"},
        { id: "unique_custs", label: 'analytics.totals.unique_custs', icon: <UniqueIcon />, loading: true , tooltip:"TotalsUniqueCusts" },
    ]
}